import {atom} from "recoil";
import {documentListSelector} from "../selectors/documentSelectors";

/*
 * This atom stores documents returned by documentListSelector
 */
export const documentListAtom = atom({
    key: "DocumentList",
    default: documentListSelector,
})